import { useEffect } from 'react';
import { DEFAULT_TONE, FormFieldsMap } from 'features/ai-generators/constants';

import { usePresentationMakerGeneratorForm } from './usePresentationMakerGeneratorForm';

export const usePresentationMakerGeneratorFormWithLogic = config => {
  const {
    presentationTypeId,
    defaultPresentationContent,
    footerExtraButtons,
    onClickGenerate,
    onClickRateButton,
    enabled: isAutoRetrievalEnabled
  } = config.autoGenerationConfig || {};

  const hookResult = usePresentationMakerGeneratorForm({
    defaultPresentationContent,
    footerExtraButtons,
    isAutoRetrievalEnabled,
    onClickGenerate,
    onClickRateButton,
    autoGenerationConfig: config.autoGenerationConfig
  });

  const { formMethods, handleRequestGeneration } = hookResult;
  const { reset } = formMethods;

  useEffect(() => {
    if (presentationTypeId) {
      reset();
    }
  }, [presentationTypeId, reset]);

  useEffect(() => {
    if (!presentationTypeId || defaultPresentationContent) return;

    (async () => {
      await handleRequestGeneration({
        [FormFieldsMap.Tone.key]: DEFAULT_TONE
      });
    })();
  }, [handleRequestGeneration, presentationTypeId, defaultPresentationContent]);

  return hookResult;
};
